__turbopack_context__.v({
  "container": "_0KXwiW_container",
  "link": "_0KXwiW_link",
  "links": "_0KXwiW_links",
  "title": "_0KXwiW_title",
  "variant--stacked": "_0KXwiW_variant--stacked",
});
